// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.hpht-rheology-report-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 6.5pt;
}
.hpht-rheology-report-table thead {
  display: table-header-group;
}
.hpht-rheology-report-table tr {
  break-inside: avoid;
  page-break-inside: avoid;
}
.hpht-rheology-report-table th,
.hpht-rheology-report-table td {
  padding: 3px 2px;
  border: 1px solid #20252b;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
}
.hpht-rheology-report-table thead th {
  background: #fff;
  color: #20252b;
  font-size: 6pt;
  font-weight: 700;
}
.hpht-rheology-report-table .hpht-title-row th {
  background: #ffffe5;
  font-size: 9pt;
  font-weight: 400;
  padding: 2px;
}
.hpht-rheology-report-table .highlight-header,
.hpht-rheology-report-table .highlight-cell,
.hpht-rheology-report-table .reference-row td {
  background: #ffffe5;
}
.hpht-rheology-report-table .reference-note-row td {
  padding: 3px 4px;
  text-align: left;
  white-space: normal;
}

.empty-state {
  margin: 4px 0;
  color: #69747d;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-request-report/job-request-report-tests/hpht-rheology-test-report.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AACF;AACE;EACE,2BAAA;AACJ;AAEE;EACE,mBAAA;EACA,wBAAA;AAAJ;AAGE;;EAEE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;AADJ;AAIE;EACE,gBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AAFJ;AAKE;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;AAHJ;AAME;;;EAGE,mBAAA;AAJJ;AAOE;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;AALJ;;AASA;EACE,aAAA;EACA,cAAA;EACA,kBAAA;AANF","sourcesContent":[":host {\n  display: block;\n}\n\n.hpht-rheology-report-table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n  font-size: 6.5pt;\n\n  thead {\n    display: table-header-group;\n  }\n\n  tr {\n    break-inside: avoid;\n    page-break-inside: avoid;\n  }\n\n  th,\n  td {\n    padding: 3px 2px;\n    border: 1px solid #20252b;\n    text-align: center;\n    vertical-align: middle;\n    white-space: nowrap;\n  }\n\n  thead th {\n    background: #fff;\n    color: #20252b;\n    font-size: 6pt;\n    font-weight: 700;\n  }\n\n  .hpht-title-row th {\n    background: #ffffe5;\n    font-size: 9pt;\n    font-weight: 400;\n    padding: 2px;\n  }\n\n  .highlight-header,\n  .highlight-cell,\n  .reference-row td {\n    background: #ffffe5;\n  }\n\n  .reference-note-row td {\n    padding: 3px 4px;\n    text-align: left;\n    white-space: normal;\n  }\n}\n\n.empty-state {\n  margin: 4px 0;\n  color: #69747d;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
